import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { MaterialIcons } from "@expo/vector-icons"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"

export const FollowUpItemCard = (props) => {
    return (
        <TouchableOpacity
            activeOpacity={0.8}
            style={{ borderRadius: 10, marginBottom: 10 }}
            onPress={() => props.onPress()}
        >
            <View style={{ ...styles.Card, backgroundColor: props.bgColor }}>
                <View style={styles.Col}>
                    <View style={styles.row}>{props.icon}</View>
                    <View style={{ flex: 1, paddingStart: 20 }}>
                        <OpenSansText color={"white"} fontSize={16}>
                            {props.title}
                        </OpenSansText>
                    </View>
                    <MaterialIcons color={"white"} size={28} name={"chevron-right"} />
                </View>
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    Col: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "space-between",
        alignItems: "center"
    },
    Card: {
        alignContent: "center",
        justifyContent: "center",
        height: 81,
        borderRadius: 10,
        padding: 10
    },
    row: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
        width: 47,
        height: 47,
        backgroundColor: "white"
    }
})
